import ErrorBoundary from './ErrorBoundary'
import {Route} from 'navigation/types'
import {navigation} from 'navigation'
import router from 'navigation/router'

type PrivateNavigatorErrorBoundaryProps = {
    currentRoute: Route
    fallbackRoute: Route
    key: string
}

class PrivateNavigatorErrorBoundary extends ErrorBoundary<PrivateNavigatorErrorBoundaryProps> {
    componentDidCatch(error: Error) {
        super.componentDidCatch(error)

        const {
            currentRoute,
            fallbackRoute,
        } = this.props

        if (router.compare(currentRoute, fallbackRoute)) {
            throw new Error('unable to render fallback route')
        }

        navigation.replace(fallbackRoute.name, fallbackRoute.params)
    }

    render() {
        const {error} = this.state

        if (error) {
            return null
        }

        return super.render()
    }
}

export {PrivateNavigatorErrorBoundary}
